<template>
  <div class="detail-books">
    <div class="detail-books__head display-flex-center justify-content-between">
      <router-link
        :to="{
          name: 'library',
          query: {
            lop: lessonData.classId,
            mon: $route.query.mon ? $route.query.mon : 0,
            nhom: $route.query.nhom ? $route.query.nhom : 0,
            tab: tabLesson,
          },
        }"
        class="secondary-color-txt font-size-15 font-family-Semibold"
      >
        <i class="icon-close secondary-color-txt font-size-10"></i>
        Thoát
      </router-link>
      <h3
        class="font-size-15 secondary-color-txt font-sanpro-semibold margin-0"
      >
        {{ lessonData.title }}
      </h3>
      <div class="btn-function"></div>
    </div>
    <div class="detail-books__body">
      <!-- Fix bug: hiển thị lại phần kịch bản dạy học, xem toàn màn hình và nhìn rõ được nội dung kịch bản
      Modified: anhdd (26/8/2022)
      Bỏ class container -->
      <div class="">
        <div class="detail-books__tabs tabs-center effect-transition-fast">
          <b-tabs class="book-detail__tabs__content">
            <b-tab @click="changeTab(0)">
              <template v-slot:title>Bài giảng tham khảo</template>
              <div
                id="script_docs_pptx"
                class="detail-books__tabs__body lib-lesson__tabs__body"
                :class="{ 'is-zoom': isZoomFile }"
              >
                <div
                  id="lesson_img"
                  class="
                    lib-lesson__imgs lib-lesson__imgs--pptx
                    effect-transition-fast
                    display-flex
                  "
                >
                  <div
                    id="lesson_img_wrap"
                    class="lib-lesson__imgs__wrap display-flex"
                    v-if="lessonData.lessonPlan"
                  >
                    <vue-custom-scrollbar
                      class="item text-center effect-transition-fast"
                      v-for="num in pageSettingLessonPlan.pageLoaded"
                      :key="num"
                      :style="`width: ${sizeBoxSlide.width}px`"
                    >
                      <img
                        class="item__img effect-transition-fast"
                        :style="styleZoom"
                        :src="`${imgCdnUrl}${lessonData.lessonPlan.fileName}-${num}.jpg`"
                        :alt="lessonData.lessonPlan.pathView"
                      />
                    </vue-custom-scrollbar>
                  </div>
                  <p
                    v-else
                    class="
                      font-size-22
                      text-center
                      secondary-color-txt
                      full-width
                    "
                  >
                    Đang cập nhật dữ liệu
                  </p>
                </div>
              </div>
            </b-tab>
            <b-tab @click="changeTab(1)">
              <template v-slot:title>Kịch bản dạy học</template>
              <vue-custom-scrollbar
                id="script_docs"
                class="detail-books__tabs__body"
                @ps-scroll-y="handleScrollScript"
              >
                <div
                  id="lesson_img_script"
                  class="
                    lib-lesson__imgs lib-lesson__imgs--script
                    effect-transition-fast
                    display-flex
                  "
                >
                  <div
                    id="lesson_img_script_wrap"
                    class="lib-lesson__imgs__wrap"
                    v-if="lessonData.script"
                  >
                    <div
                      :id="`item_script_${num}`"
                      class="
                        item item-script
                        text-center
                        effect-transition-fast
                      "
                      v-for="num in pageSettingScript.pageLoaded"
                      :key="num"
                      :style="`width: ${sizeBoxSlide.width}px`"
                    >
                      <!-- :style="`width: ${sizeBoxSlide.width}px`" -->
                      <img
                        class="item__img"
                        :style="styleZoom"
                        :src="`${imgCdnUrl}${lessonData.script.fileName}-${num}.jpg`"
                        :alt="lessonData.script.pathView"
                      />
                    </div>
                  </div>
                  <p
                    v-else
                    class="
                      font-size-22
                      text-center
                      secondary-color-txt
                      full-width
                    "
                  >
                    Đang cập nhật dữ liệu
                  </p>
                </div>
              </vue-custom-scrollbar>
            </b-tab>
          </b-tabs>
        </div>
        <div
          class="book-viewer__sidebar lib-lesson__sidebar"
          :class="{
            active: isOpenSidebar,
            'mobile-close': !openSidebarMobile,
            'mobile-open': openSidebarMobile,
          }"
        >
          <div
            class="
              book-viewer__sidebar__icons
              position-rel
              display-flex
              flex-direction-col
              justify-content-between
            "
            :class="{ heightCollapse: heightCollapse }"
          >
            <div class="icon-top">
              <a
                href="javascript:;"
                :class="{ active: keySidebarActive === keySidebarInfo }"
                @click="openSidebar(keySidebarInfo)"
                class="total-a"
                :title = "tabActive == 0?'Thông tin':'Thông tin'"
              >
                <i class="icon-info font-size-20"></i>
              </a>
              <!-- <a href="javascript:;" :class="{'active': keySidebarActive === keySideDownload}" @click="openSidebar(keySideDownload)">
								<i class="icon-download font-size-20"></i>
							</a> -->
              <a :title = "tabActive == 0?'Tải xuống':'Tải xuống'" href="javascript:;" @click="handleDownloadFiles">
                <i class="icon-download font-size-20"></i>
              </a>
            </div>
          </div>
          <Sidebar
            :keySidebarActive="keySidebarActive"
            :dataSource="lessonData"
          />
        </div>
      </div>
    </div>
    <div
      class="
        detail-books__footer
        lib-detail__footer
        color_bg_gray_light
        display-flex-center
        justify-content-between
        position-rel
      "
    >
      <a
        href="javascript:;"
        class="
          primary-color
          font-size-16 font-sanpro-semibold
          book-viewer__footer__cats
          border-rd-20
          position-rel
          display-flex-center
          justify-content-center
        "
        @click="handleToggleLessonCats"
        :class="{ 'btn-2': openLessonCats }"
      >
        <img
          src="@/assets/imgs/icon-list.png"
          class="icon-list"
          alt="Danh sách bài giảng"
        />
        <span class="only-pc">Danh sách</span>
      </a>
      <div class="book-viewer__paging display-flex-center">
        <button title="Quay lại trang trước" class="prev-page" @click="prevPage">
          <i class="icon-prev color-light"></i>
        </button>
        <div class="book-viewer__paging__input">
          <span
            class="text-center"
            v-if="lessonData && (lessonData.lessonPlan || lessonData.script)"
          >
            {{
              tabActive === 0
                ? pageSettingLessonPlan.page
                : pageSettingScript.page
            }}
            /
            {{
              tabActive === 0 && lessonData.lessonPlan
                ? lessonData.lessonPlan.totalPage
                : lessonData.script
                ? lessonData.script.totalPage
                : 0
            }}
          </span>
        </div>
        <button title="Chuyển đến trang tiếp theo" class="next-page" @click="nextPage">
          <i class="icon-next color-light"></i>
        </button>
      </div>
      <div :title="tabActive == 0?'Điều chỉnh kích cỡ kịch bản dạy học':'Điều chỉnh kích cỡ kịch bản tham khảo'" class="book-viewer__zoom-switch display-flex-center">
        <div class="book-viewer__zoom">
          <button class="zoom-out" @click="handleZoom('-')">
            <i class="icon-minus font-size-14 secondary-color-txt"></i>
          </button>
          <span class="ratio-book">{{ formattedZoom }} %</span>
          <button class="zoom-in" @click="handleZoom('+')">
            <i class="icon-plus font-size-14 secondary-color-txt"></i>
          </button>
        </div>
      </div>
      <div
        class="book-viewer__toggle-icon-sidebar only-mobile"
        @click="handleToggleOpenSidebarMobile"
      >
        <div
          class="
            book-viewer__toggle-icon-sidebar__wrap
            display-flex-center
            justify-content-center
          "
        >
          <i class="icon-more primary-color font-size-22"></i>
        </div>
      </div>
    </div>
    <div class="book-viewer__cats" :class="{ active: openLessonCats }">
      <div class="book-viewer__cats__wrap">
        <h2
          class="
            book-viewer__cats__title
            primary-color-txt
            font-size-24 font-sanpro-semibold
            lib-lesson__cats__title
          "
        >
          Danh sách
        </h2>
      </div>
      <vue-custom-scrollbar
        class="scroll-area scroll-area__cats"
        :settings="settingsViewBookSidebar"
      >
        <div class="book-viewer__cats__list">
          <div
            class="book-viewer__cats__wrap lib-lesson__pages"
            v-if="lessonData && (lessonData.lessonPlan || lessonData.script)"
          >
            <div
              class="item position-rel"
              v-for="(item, index) in tabActive === 0 && lessonData.lessonPlan
                ? lessonData.lessonPlan.totalPage
                : lessonData.script
                ? lessonData.script.totalPage
                : 0"
              :class="{
                active: pageSettingLessonPlan.page === item,
                'item--2': tabActive === 1,
              }"
              @click="directPage(item)"
              :key="index"
            >
              <div class="item__head">
                <div class="img__wrap" v-if="openLessonCats">
                  <img
                    :src="
                      lessonData[tabActive === 0 ? 'lessonPlan' : 'script']
                        .fileName
                        ? `${imgCdnUrl}${
                            lessonData[
                              tabActive === 0 ? 'lessonPlan' : 'script'
                            ].fileName
                          }-${item}.jpg`
                        : img404
                    "
                    :alt="lessonData.title"
                  />
                </div>
              </div>
              <h4 class="item__title margin-0">{{ item }}</h4>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import {
  TAB_LESSON,
  DETAIL_TAB_INFO,
  DETAIL_TAB_DOWNLOAD,
} from "./../_store/constants";
import vueCustomScrollbar from "vue-custom-scrollbar";
import {
  getLesson,
  downloadMultiLessonFile,
  delFileZipLesson,
  updatecountview,
} from "./../_api/";
import { mapActions } from "vuex";
import { APP_CONFIG } from "@/utils/constants";
import { scrollTo } from "@/helpers/functions";
import mixinsFiles from "@/components/content-files/mixinsFiles";
const img404 = require(`@/assets/images/img_404.jpg`);

export default {
  name: "ViewDetailBooks",
  mixins: [mixinsFiles],
  components: {
    vueCustomScrollbar,
    Sidebar: () => import("./../_components/detail/Sidebar.vue"),
  },
  data() {
    return {
      imgCdnUrl: APP_CONFIG.bookImgCdnUrl,
      apiUrl: APP_CONFIG.appUrl,
      lessonData: {},
      pageLoading: 3,
      // page: 0,
      // pageLoaded: 0,
      scale: 1,
      slideTranslateX: 0,
      sizeBoxSlide: {
        width: 0,
        height: 0,
      },
      tabLesson: TAB_LESSON,
      isOpenSidebar: false,
      openLessonCats: false,
      keySidebarActive: "", //download Or Info
      keySidebarInfo: DETAIL_TAB_INFO,
      keySideDownload: DETAIL_TAB_DOWNLOAD,
      numberBookViewOpenSidebar: 1.3,
      tabActive: 0,
      pageSettingLessonPlan: {
        page: 0,
        pageLoaded: 0,
      },
      pageSettingScript: {
        page: 0,
        pageLoaded: 0,
      },
      scrollPosition: 0,
      lastPageOffsetTop: 0,
      settingsViewBookSidebar: {
        maxScrollbarLength: 300,
      },
      isZoomFile: false,
      img404,
      styleZoom: { width: "" },
      idBookLessonPlanFile: 0,
      heightCollapse: true,
      openSidebarMobile: false,
    };
  },
  computed: {
    lessonId() {
      return this.$router.history.current.params.id;
    },
    formattedZoom() {
      return Number.parseInt(this.scale * 100);
    },
  },
  created() {
    // window.addEventListener('keyup', this.onKeyup)
    this.getLessonDetail();
    console.log(this.tabLesson)
  },
  mounted() {
    this.setSizeForSlide();
    // this.openSidebar(DETAIL_TAB_INFO);
  },
  methods: {
    ...mapActions("common", ["setLoading"]),

    getLessonDetail() {
      let self = this;
      self.setLoading(true);
      getLesson(self.lessonId)
        .then((res) => {
          if (res && res.data && !res.errors) {
            self.lessonData = res.data;
            this.idBookLessonPlanFile = res.data.script.bookLessonPlanFileId;

            if (
              self.tabActive === 0 &&
              res.data.lessonPlan &&
              res.data.lessonPlan.totalPage > 0
            ) {
              self.pageSettingLessonPlan.page = 1;
              self.pageSettingLessonPlan.pageLoaded = self.pageLoading;
            } else if (
              self.tabActive === 1 &&
              res.data.script &&
              res.data.script.totalPage > 0
            ) {
              self.pageSettingScript.page = 1;
              self.pageSettingScript.pageLoaded = self.pageLoading;
            }
          }
        })
        .finally(() => self.setLoading(false));
    },

    setSizeForSlide() {
      setTimeout(() => {
        this.sizeBoxSlide.width =
          document.getElementById(`lesson_img`).clientWidth;
        this.sizeBoxSlide.height =
          document.getElementById(`lesson_img`).clientHeight;
        this.openSidebar(DETAIL_TAB_INFO);
      }, 500);
    },

    onKeyup(e) {
      // console.log(e);
      // e.preventdefault()
      // e.keyCode === 37 && this.prevPage()
      // e.keyCode === 39 && this.nextPage()
    },

    nextPage() {
      if (this.tabActive === 0 && this.lessonData.lessonPlan) {
        if (
          this.pageSettingLessonPlan.pageLoaded <
          this.lessonData.lessonPlan.totalPage
        ) {
          this.pageSettingLessonPlan.pageLoaded += 1;
        }

        if (
          this.pageSettingLessonPlan.page < this.lessonData.lessonPlan.totalPage
        ) {
          this.pageSettingLessonPlan.page += 1;
          // Await render dom
          this.setSlideAction();
        }
      } else if (this.lessonData.script) {
        /**
         * Fix bug chuyển trang kịch bản dạy học
         * Modified: anhdd (25/8/2022)
         */
        if (this.pageSettingScript.page < this.lessonData.script.totalPage) {
          this.pageSettingScript.page += 1;
          this.setScrollToPage(this.pageSettingScript.page);
        }
      }
      // console.log(
      //   "this.pageSettingLessonPlan.page",
      //   this.pageSettingLessonPlan.page
      // );
      // console.log("tabActive", this.tabActive);
      // console.log("pageSettingScript.page", this.pageSettingScript.page);
      // console.log(
      //   "this.lessonData.lessonPlan.totalPage",
      //   this.lessonData.script.totalPage
      // );
    },

    prevPage() {
      if (this.tabActive === 0) {
        if (this.pageSettingLessonPlan.page > 1) {
          this.pageSettingLessonPlan.page -= 1;
          this.setSlideAction("-");
        }
      } else if (this.lessonData.script) {
        /**
         * Fix bug chuyển trang kịch bản dạy học
         * Modified: anhdd (25/8/2022)
         */
        if (this.pageSettingScript.page > 1) {
          this.pageSettingScript.page -= 1;
          this.setScrollToPage(this.pageSettingScript.page);
        }
      }
      // console.log(
      //   "this.pageSettingLessonPlan.page",
      //   this.pageSettingLessonPlan.page
      // );
    },

    setSlideAction(type = "+", betweenPageCurr = 0) {
      let elementActive = document.getElementById(`lesson_img`);
      let elementSlideSwrap = document.getElementById(`lesson_img_wrap`);
      if (elementActive) {
        let widthElm = elementActive.clientWidth;
        // Support for direct page form input or click pageindex
        if (betweenPageCurr > 0) {
          widthElm *= betweenPageCurr;
        }
        this.slideTranslateX =
          type === "+"
            ? this.slideTranslateX - widthElm
            : this.slideTranslateX + widthElm;
        elementSlideSwrap.style.transform = `translateX(${this.slideTranslateX}px)`;
        elementSlideSwrap.style.transitionDuration = `300ms`;
      }
    },

    handleZoom(type = "+") {
      let self = this;
      if (type === "+") {
        this.scale = this.scale < 2 ? this.scale + 0.1 : this.scale;
      } else {
        this.scale = this.scale > 0 ? this.scale - 0.1 : this.scale;
      }
      this.isZoomFile = this.scale === 1 ? false : true;
      let elems = document.getElementsByClassName("item__img");
      let elemsLength = elems.length;
      let elementSlideWidth =
        this.tabActive === 0
          ? document.getElementById(`lesson_img`).clientWidth
          : document.getElementById(`lesson_img_script`).clientWidth;

      this.styleZoom.width = `${elementSlideWidth * self.scale}px`;
      if (this.scale !== 1) {
        this.styleZoom = {
          ...this.styleZoom,
          "max-width": "initial",
          "max-height": "initial",
        };
      }
    },

    openSidebar(type) {
      this.heightCollapse = !this.heightCollapse;
      let self = this;
      self.openLessonCats = false;
      if (type === self.keySidebarActive) {
        self.isOpenSidebar = false;
        self.keySidebarActive = "";
      } else {
        self.isOpenSidebar = true;
        self.keySidebarActive = type;
      }

      if (window.innerWidth > 991 && self.isOpenSidebar) {
        self.setSpaceSizeForOpenSidebarBox();
      }

      if (!self.isOpenSidebar) {
        self.resetPageWhenOfBoxsTransition();
      }
    },

    setSpaceSizeForOpenSidebarBox() {
      let self = this;
      let bodyBookBox =
        document.getElementsByClassName("detail-books__tabs")[0];
      let sidebarBox = document.getElementsByClassName(
        "book-viewer__sidebar"
      )[0];
      let widthSidebarBox = sidebarBox.clientWidth;

      if (bodyBookBox) {
        bodyBookBox.style.paddingLeft = 0;
        bodyBookBox.style.paddingRight = `${widthSidebarBox}px`;
        // Set again for box img
        self.sizeBoxSlide.width = bodyBookBox.clientWidth - widthSidebarBox;
        self.tabActive === 0 &&
          self.resetTransitionSlide(self.sizeBoxSlide.width);
      }
    },

    resetPageWhenOfBoxsTransition() {
      let self = this;
      let bodyBookBox =
        document.getElementsByClassName("detail-books__tabs")[0];
      bodyBookBox.style.paddingLeft = 0;
      bodyBookBox.style.paddingRight = 0;
      // console.log('Resset: ', bodyBookBox.clientWidth)
      this.sizeBoxSlide.width = bodyBookBox.clientWidth;
      this.tabActive === 0 &&
        this.resetTransitionSlide(bodyBookBox.clientWidth);
    },

    resetTransitionSlide(width) {
      // console.log('width transition: ', width, this.pageSettingLessonPlan.page)
      let bodyBookBox =
        document.getElementsByClassName("detail-books__tabs")[0].clientWidth;
      let elementSlideSwrap = document.getElementById(`lesson_img_wrap`);
      // Page = 1 => transition = 0
      this.slideTranslateX =
        parseInt(this.pageSettingLessonPlan.page - 1) * parseInt(width) * -1;
      elementSlideSwrap.style.transform = `translateX(${this.slideTranslateX}px)`;
      elementSlideSwrap.style.transitionDuration = `300ms`;
    },

    setScrollToPage(page) {
      let targetPage = page || this.pageSettingScript.page;
      let elem = document.getElementById(`item_script_${targetPage}`);
      if (elem) {
        let topPos = elem.offsetTop;
        scrollTo(document.getElementById("script_docs"), topPos, 600);
      }
    },

    handleScrollScript(event) {
      let currentScrollPosition = event.srcElement.scrollTop;
      let itemScript = document.getElementsByClassName("item-script")[0];
      let itemMargin = 25;
      let heightItem = itemScript.clientHeight;
      // Setting page Curr
      this.pageSettingLessonPlan.page =
        Math.ceil(currentScrollPosition / (heightItem + itemMargin)) || 1;
      // Setting pageLoaded
      if (
        currentScrollPosition > this.scrollPosition &&
        this.lessonData.script
      ) {
        try {
          this.lastPageOffsetTop = document.getElementById(
            `item_script_${this.pageSettingLessonPlan.pageLoaded}`
          ).offsetTop;
        } catch (error) {}
        if (currentScrollPosition + 50 >= this.lastPageOffsetTop) {
          let space2TotalPage =
            this.lessonData.lessonPlan.totalPage -
            this.pageSettingLessonPlan.pageLoaded;
          let setPageLoad =
            space2TotalPage > this.pageLoading
              ? this.pageLoading
              : space2TotalPage;
          this.pageSettingLessonPlan.pageLoaded += setPageLoad;
        }
        this.scrollPosition = currentScrollPosition;
      }
    },

    handleToggleLessonCats() {
      let self = this;
      self.openLessonCats = !self.openLessonCats;
      self.isOpenSidebar = false;
      self.keySidebarActive = "";

      if (window.innerWidth > 991 && self.openLessonCats) {
        self.setSpaceSizeForOpenCatBox();
      }
      if (!self.openLessonCats) {
        self.resetPageWhenOfBoxsTransition();
      }
    },

    setSpaceSizeForOpenCatBox() {
      let self = this;
      let bodyBookBox =
        document.getElementsByClassName("detail-books__tabs")[0];
      let catBox = document.getElementsByClassName("book-viewer__cats")[0];
      let widthCatBox = catBox.clientWidth;

      bodyBookBox.style.paddingLeft = `${widthCatBox}px`;
      bodyBookBox.style.paddingRight = 0;
      self.sizeBoxSlide.width = bodyBookBox.clientWidth - widthCatBox;
      self.tabActive === 0 &&
        self.resetTransitionSlide(bodyBookBox.clientWidth - widthCatBox);
    },

    directPage(page) {
      let self = this;
      if (this.tabActive === 0 && this.lessonData.lessonPlan) {
        let typeDirect = this.pageSettingLessonPlan.page > page ? "-" : "+";
        let spaceBetweenThisPage = Math.abs(
          this.pageSettingLessonPlan.page - page
        );
        this.pageSettingLessonPlan.page = page;
        this.pageSettingLessonPlan.pageLoaded =
          page === this.lessonData.lessonPlan.totalPage ||
          this.lessonData.lessonPlan.totalPage - page < 3
            ? page
            : page + 3;
        this.setSlideAction(typeDirect, spaceBetweenThisPage);
      } else if (this.lessonData.script) {
        this.pageSettingScript.page = page;
        this.pageSettingScript.pageLoaded =
          page === this.lessonData.script.totalPage ||
          this.lessonData.script.totalPage - page < 3
            ? page
            : page + 3;
        // Await render data
        setTimeout(() => {
          this.setScrollToPage(page);
        }, 200);
      }
    },

    changeTab(tab) {
      this.tabActive = tab;
      if (
        tab === 0 &&
        this.lessonData.lessonPlan &&
        this.lessonData.lessonPlan.totalPage > 0 &&
        this.pageSettingLessonPlan.page === 0
      ) {
        this.pageSettingLessonPlan.page = 1;
        this.pageSettingLessonPlan.pageLoaded = this.pageLoading;
      } else if (
        tab === 1 &&
        this.lessonData.script &&
        this.lessonData.script.totalPage > 0 &&
        this.pageSettingScript.page === 0
      ) {
        updatecountview(this.idBookLessonPlanFile).then((res) => {
          // if(res){
          // 	console.log('réerserserser', res)
          // }
        });
        this.pageSettingScript.page = 1;
        this.pageSettingScript.pageLoaded = this.pageLoading;
      }
    },

    handleDownloadFiles() {
      let self = this;
      self.setLoading(true);
      downloadMultiLessonFile(self.lessonId).then((res) => {
        if (res.data && !res.errors) {
          self
            .downloadDocs(
              `${self.apiUrl}/${res.data}`,
              self.lessonData.title,
              true
            )
            .then((response) => {
              if (response && response.statusText === "OK") {
                let fileNameDel = res.data.replace("Uploads/", "");
                fileNameDel = fileNameDel.replace(".zip", "");
                // setTimeout(() => {
                //   console.log('Settimeout ABC: ')
                delFileZipLesson(fileNameDel).finally(() =>
                  self.setLoading(false)
                );
                // }, 60*1000*2)
              }
            });
        }
      });
    },

    handleToggleOpenSidebarMobile() {
      this.openSidebarMobile = !this.openSidebarMobile;
    },
  },
};
</script>

<style lang="scss" scoped>
// Variables
@import "./../../../assets/scss/variables";

.heightCollapse {
  height: 53px;
}

.detail-books {
  &__head {
    height: 55px;
    border-bottom: 1px solid $color_border_line;
    padding: 0 35px;

    .btn-function {
      .btn-prepare {
        width: 140px;
        margin-right: 18px;
        &:hover {
          opacity: 0.8;
        }
      }
      .btn-show {
        width: 135px;

        &:hover {
          * {
            color: $primary_color;
          }
        }
      }
    }
  }

  &__body {
    padding-top: 20px;
  }

  &__body,
  &__tabs {
    height: calc(100vh - 125px);
    overflow: hidden;
  }
  &__footer {
    height: 70px;
    border-top: 1px solid $color_border_line;
    padding: 0 35px;
    z-index: 12;

    .icon-list {
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }

    .book-viewer__footer__cats {
      margin-right: 7px;
      height: 30px;
      min-width: 140px;
      line-height: 28px;
      i {
        margin-right: 8px;
      }
    }

    .book-viewer__zoom {
      width: 130px;
      overflow: hidden;
      // margin-right: 18px;
      height: 30px;

      .zoom-out,
      .zoom-in {
        margin-left: 5px;
      }
    }
  }

  &__tabs {
    &__body {
      padding: 35px 0;
    }
  }
}

.lib-lesson__cats__title {
  border-bottom: 2px solid $color_border_line;
  padding-bottom: 10px;
  margin-bottom: 25px;
}

.lib-lesson__pages {
  @extend .display-flex-wrap;
  .item {
    width: calc((100% / 2) - 15px);
    margin-bottom: 20px;

    &:nth-child(odd) {
      margin-right: 30px;
    }

    &__head {
      @extend .aspect-ratio;
      @extend .aspect-ratio--16-9;
      border: 1px solid transparent;

      &:before {
        @extend .bg-color-light;
      }
    }

    &__title {
      @extend .primary-bg-color;
      @extend .display-inline-block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0 0 10px 0;
      @extend .font-size-13;
      @extend .color-light;
      padding: 5px 10px;
      line-height: 1;
    }

    &.active,
    &:hover {
      .item__head {
        border-color: $primary_color;
      }
    }

    &--2 {
      @extend .text-center;

      .item {
        &__head {
          max-width: 70%;
          @extend .margin-center;
          @extend .aspect-ratio--1-1-5;
        }

        &__title {
          @extend .display-block;
          @extend .font-size-16;
          @extend .primary-color-txt;
          padding: 5px 10px;
          line-height: 1;
          @extend .bg-transparent;
          @extend .position-rel;
          @extend .text-center;
        }
      }
    }
  }
}

.lib-lesson__imgs {
  width: 100%;
  overflow: hidden;

  &--pptx {
    img,
    .item {
      // max-height: 70%;
      max-height: calc(100vh - 230px);
    }

    .item {
      overflow: auto;
      max-height: calc(100vh - 230px);
    }
  }
}

.lib-detail__footer {
  .book-viewer__zoom {
    margin: 0;
  }
}

.book-viewer {
  &__sidebar {
    top: 55px;
  }

  &__paging {
    > * {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
    button,
    &__input {
      //, &__zoom
      height: $height_btn;
      line-height: 28px;
    }
    button {
      @extend .btn-main;
      @extend .border-rd-20;
      min-width: 60px;
      @extend .text-center;
      &:hover {
        i,
        i:before {
          @extend .primary-color;
        }
      }
    }
    &__input {
      width: 100px;
      @extend .border-rd-20;
      @extend .bg-color-light;
      border: 1px solid $color_light;
      overflow: hidden;
      @extend .text-center;
      * {
        @extend .secondary-color-txt;
        @extend .font-size-16;
      }
      &:hover {
        border-color: $primary_color;
      }
      input {
        @extend .border-rd-20;
        &:focus {
          border: 1px solid $primary_color;
        }
      }
    }
    input {
      @extend .border-0;
      @extend .full-box;
      @extend .text-center;
      &:active,
      &:focus,
      &:visited {
        outline: 0;
      }
    }
    .show-pages--mobile {
      display: none;
    }
    &.has-exercise {
      @media screen and (max-width: 767px) {
        .book-viewer__paging__input {
          width: 65px;
          span {
            min-width: 100%;
          }
        }
      }
      @media screen and (min-width: 360px) and (max-width: 767px) {
        button {
          min-width: 45px;
        }
      }
      @media screen and (max-width: 359px) {
        button {
          min-width: 37px;
        }
        > * {
          margin-right: 8px;
        }
      }
    }
    @media screen and (max-width: 991px) {
      .show-pages {
        display: none;
        &--mobile {
          display: block;
        }
      }
    }
  }
  &__zoom {
    width: 115px;
    @extend .bg-color-light;
    @extend .border-rd-20;
    @extend .font-size-16;
    @extend .secondary-color-txt;
    @extend .display-flex-center;
    @extend .justify-content-between;
    overflow: hidden;
    margin-right: 18px;
    button {
      @extend .bg-transparent;
      @extend .border-0;
      @extend .secondary-color-txt;
      @extend .font-size-20;
      &.zoom {
        &-out {
          margin-left: 5px;
        }
        &-in {
          margin-right: 5px;
        }
      }
      &:active,
      &:focus,
      &:visited {
        outline: 0;
      }
    }
    &__mobile {
      .exercise {
        margin-right: 40px;
        a {
          &:not(:last-child) {
            margin-right: 35px;
          }
        }
        @media screen and (min-width: 360px) and (max-width: 575px) {
          margin-right: 25px;
          a {
            &:not(:last-child) {
              margin-right: 25px;
            }
          }
        }
      }
    }
  }
}

#script_docs {
  max-height: calc(100vh - 200px);
  overflow: auto;

  .item {
    margin-bottom: 25px;
    @extend .bg-color-light;
  }
}

// #script_docs_pptx {
// 	// max-height: auto;
// 	// overflow: hidden!important;
// 	// #lesson_img {
// 	// 		max-height: calc(100vh - 230px);
// 	// }

// 	&.is-zoom {
// 		// #lesson_img {
// 		// 	overflow: auto;
// 		// }
// 		// max-width: 100%;
// 		// max-height: calc(100vh - 200px);
// 	}
// }

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
}

@media screen and (max-width: 991px) {
  .lib-detail__footer {
    .book-viewer__footer__cats {
      min-width: auto;
    }
  }

  .lib-lesson__sidebar {
    &.active,
    &.active.mobile-open {
      -webkit-transform: translate(0px, 0px);
      transform: translate(0px, 0px);
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .lib-detail__footer {
    .book-viewer__zoom {
      width: 115px;
    }
  }
}

@media screen and (min-width: 576px) and (max-width: 991px) {
  .lib-lesson__sidebar {
    &.mobile-close {
      -webkit-transform: translate(calc(95vw), 0px);
      transform: translate(calc(95vw), 0px);
    }

    &.mobile-open:not(.active) {
      -webkit-transform: translate(calc(75vw), 0px);
      transform: translate(calc(75vw), 0px);
    }
  }
}

@media screen and (max-width: 767px) {
  .lib-detail__footer {
    .book-viewer__zoom {
      width: 100%;
      font-size: 12px;
      margin: 0;

      .ratio-book {
        width: 60px;
        text-align: center;
        font-size: 13px;
      }
      .zoom-in,
      .zoom-out {
        margin: 0;
      }
    }

    .book-viewer__paging__input {
      width: 75px;
    }

    .book-viewer__paging button {
      min-width: 25px;
      width: 25px;
      height: 25px;
      line-height: 23px;
    }
  }
  .detail-books__footer,
  .detail-books__head {
    padding: 0 15px;
  }

  .book-viewer__zoom-switch {
    max-width: 110px;
  }
}

@media screen and (min-width: 576px) and (max-width: 767px) {
  .lib-detail__footer {
    .book-viewer__paging button {
      min-width: 30px;
    }
  }
}

@media screen and (max-width: 575px) {
  .lib-lesson__sidebar {
    &.mobile-close {
      -webkit-transform: translate(calc(95vw), 0px);
      transform: translate(calc(95vw), 0px);
    }

    &.mobile-open:not(.active) {
      -webkit-transform: translate(calc(80vw), 0px);
      transform: translate(calc(80vw), 0px);
    }
  }
  .lib-detail__footer {
    .book-viewer__paging button {
      min-width: 25px;
      width: 25px;
      height: 25px;
      line-height: 25px;
      padding: 0;
    }
    .book-viewer__zoom {
      .zoom-in,
      .zoom-out {
        margin: 0;
        padding: 0;
        i {
          font-size: 13px;
        }
      }
      .zoom-out {
        padding-left: 5px;
      }
      .zoom-in {
        padding-right: 5px;
      }
    }
  }
}
</style>